import { render, staticRenderFns } from "./CustomComponent.vue?vue&type=template&id=ac6ff3cc"
import script from "./CustomComponent.vue?vue&type=script&lang=js"
export * from "./CustomComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomComponent.vue?vue&type=style&index=0&id=ac6ff3cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports